import { Vector2 } from "peet-math";
import { ViewPort } from "./viewport";

export abstract class Control {
  public visible: boolean;
  public position: Vector2;
  public triggerRedraw: () => void;
  
  constructor() {
    this.visible = true;
    if ((this.position == null)) { this.position = new Vector2(0, 0); }
  }

  public isPlanPointInside?(point: Vector2): boolean {
    return false;
  }

  public isViewportPointInside?(viewport: ViewPort, point: Vector2): boolean {
    return false;
  }

  public handleMouseIn?(viewport: ViewPort, point: Vector2) { }
  public handleMouseOut?(viewport: ViewPort, point: Vector2) { }

  abstract render(viewport: ViewPort, canvasCtx: CanvasRenderingContext2D);
}